import { render } from "./Etsetsenekou.vue?vue&type=template&id=5c9c0f58"
import script from "./Etsetsenekou.vue?vue&type=script&lang=js"
export * from "./Etsetsenekou.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__